import { combineReducers } from 'redux';
import { createSelector } from 'reselect';
import { interfaceReducers } from './interface/interface.state';
import { getCampaignsFilterRules, rulesReducer } from './rules/rules.state';
import { filtersReducer } from './filters/filters.state';
import { CALLBACK_BY_OPERATOR } from './rules';
import { getCampaigns } from '../campaigns.state';

export const filterCampaigns = (campaigns, rules = []) => {
    const filteredCampaigns = Object.values(campaigns.data)
        .filter(campaign => rules
            .every(rule => CALLBACK_BY_OPERATOR[rule.operator](campaign, rule)));

    return {
        ...campaigns,
        data: filteredCampaigns,
    };
};

export const createCampaignsSelector = rules => (state) => {
    const campaigns = getCampaigns(state);
    return filterCampaigns(campaigns, rules);
};

export const getFilteredCampaigns = createSelector([
    getCampaigns, getCampaignsFilterRules,
], (campaigns, rules) => filterCampaigns(campaigns, rules));

export const campaignsFiltersReducers = combineReducers({
    interface: interfaceReducers,
    rules: rulesReducer,
    filters: filtersReducer,
});
